export default {
  title: "Need help?",
  message: "Write us at <a href=\"mailto:podpora{'@'}provocator.ai\">:podpora{'@'}provocator.ai</a> and we will get back to you as soon as possible. Don't forget to describe your problem in as much detail as possible, including screenshots, specific URLs, and other necessary information.",
  copyUrl: "Copy current URL",
  urlCopied: "URL was copied",
};
